import { IEditStatePayload, IGetStateList, IStateCreate, IStateDetails, IStateListSearch } from "../../../types/master/stateInterface";
import { StateActionTypes, StateActions } from "../../actionTypes/master/stateActionTypes";

export const createState = (payload: IStateCreate): StateActionTypes => ({
  type: StateActions.CREATE_STATE,
  payload,
});

export const getStateList = (payload: IStateListSearch): StateActionTypes => ({
  type: StateActions.GET_STATE_LIST,
  payload,
});

export const setStateList = (branchList: Array<IGetStateList>) : StateActionTypes => ({
  type: StateActions.SET_STATE_LIST,
  payload: branchList
})

export const setStateListPageCount = (payload:number): StateActionTypes => ({
  type: StateActions.SET_STATE_LIST_PAGE_COUNT,
  payload
})

export const deleteState = (id: number): StateActionTypes => ({
  type: StateActions.DELETE_STATE,
  payload: id,
});

export const getStateDataById = (id: number | string): StateActionTypes => ({
  type: StateActions.GET_STATE_DATA_BY_ID,
  payload: id
})

export const setStateDataById = (payload: IStateDetails) => ({
  type: StateActions.SET_STATE_DATA_BY_ID,
  payload
})

export const editState = (payload: IEditStatePayload) => ({
  type: StateActions.EDIT_STATE_DATA_BY_ID,
  payload,
});
